var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"leb-stream"},[_c('video',{staticClass:"stream",attrs:{"id":"leb-video-container","playsinline":"","webkit-playsinline":"","x5-video-player-fullscreen":""}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLoading),expression:"showLoading"}],staticClass:"loading"})])
}
var staticRenderFns = []

export { render, staticRenderFns }